import React from 'react';
import './setupHttp';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import { AuthProvider } from './contexts/AuthContext';
import { PracticeProvider } from './contexts/PracticeContext';
import { FeatureFlagsProvider } from './contexts/FeatureFlagsContext';
import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
      <AuthProvider>
        <PracticeProvider>
          <FeatureFlagsProvider>
            <ThemeProvider theme={theme}>
              <App />
            </ThemeProvider>
          </FeatureFlagsProvider>
        </PracticeProvider>
      </AuthProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
